import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const PARENT_KEY = "zunii_parent_token";
export const KID_KEY = "zunii_kid_token";

const withToken = (key) => {
  const inst = axios.create({ baseURL: API });
  inst.interceptors.request.use((cfg) => {
    const t = localStorage.getItem(key);
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
  });
  return inst;
};

export const parentApi = withToken(PARENT_KEY);
export const kidApi = withToken(KID_KEY);
export const publicApi = axios.create({ baseURL: API });

kidApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 403 && err.response?.data?.detail === "screen_time_up") {
      window.dispatchEvent(new Event("zunii:timeup"));
    }
    return Promise.reject(err);
  }
);

export const streamUrl = (videoId, token) => `${API}/videos/${videoId}/stream?auth=${token}`;
export const thumbUrl = (videoId, token) => `${API}/videos/${videoId}/thumb?auth=${token}`;

export function errMsg(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}
